import { useEffect, useState } from "react";
import styles from '../apppay.module.css';
import { Link } from "react-feather";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { loadStripe } from "@stripe/stripe-js";
import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement, PaymentRequestButtonElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useRef } from "react";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_FC);

const Step2 = ({ paymentData, connectedAccounts, setLoading, tenantDet, tenantDet2, setConnectedAccounts, isSecondPaymentStep }) => {
    const navigate = useHistory();
    const stripe = useStripe();
    const stripeRef = useRef();
    const elementsRef = useRef();
    const elementsRef2 = useRef();
    const elementContainer = useRef(null);
    const elementContainer2 = useRef(null);
    const paymentElementRef = useRef(null);
    const paymentElementRef2 = useRef(null);
    const [paymentType, setPaymentType] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [canUseApplePay, setCanUseApplePay] = useState(false);
    const [clientSecret, setClientSecret] = useState(null);
    const [clientSecret2, setClientSecret2] = useState(null);
    const [totalAmount, setTotalAmount] = useState(0);
    const cardElements = useElements();

    const connectAccount = async () => {
        setLoading(true);
        await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/create-fc-session/' + tenantDet2?.id).then(response => {
            if (response.data.secret_session !== '') {
                stripe.collectFinancialConnectionsAccounts({
                    clientSecret: response.data.secret_session
                }).then(async (result) => {
                    if (result?.financialConnectionsSession?.accounts && result?.financialConnectionsSession?.accounts?.length > 0) {
                        let accounts = result.financialConnectionsSession.accounts;

                        if (accounts.length > 0) {
                            let accountObjArr = [];
                            for (let n in accounts) {
                                let account = accounts[n];
                                accountObjArr.push({ 'fc_account_id': account['id'], 'display_name': account['display_name'], 'institution_name': account['institution_name'], 'last4': account['last4'], 'category': account['category'] });
                            }

                            await axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/add-fc-account', { 'accountObjArr': JSON.stringify(accountObjArr), 'tenant_info_id': tenantDet2?.id }).then(response => {
                                setLoading(false);
                                axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/connected-accounts/' + tenantDet2?.id).then(response => {
                                    setConnectedAccounts(response.data.data);
                                })
                            }).catch(error => {
                                setLoading(false);
                            });
                        }
                    } else {
                        setLoading(false);
                    }
                });
            } else {
                setLoading(false);
            }
        }).catch((error) => {
            setLoading(false);
        });
    }

    const bankPaymentConfirm = () => {
        try {
            let customerId = '';
            let accountId = selectedAccount.replace("acct_", "");
            if (connectedAccounts.length > 0) {
                let sAcct = connectedAccounts.filter(i => i?.fc_account_id === accountId);
                if (sAcct.length > 0) {
                    customerId = sAcct[0].fc_customer_id;
                }
            }

            setLoading(true);

            let postData = { total_amount: paymentData?.total_amount, description: paymentData?.description, amount: paymentData?.amount, rentRollId: paymentData?.rentRollId, tenantId: paymentData?.tenantId, tenantInfoId: paymentData?.tenantInfoId, cus_name: paymentData?.cus_name, cus_email: paymentData?.cus_email, cus_phone: paymentData?.cus_phone, cus_addr1: paymentData?.cus_addr1, cus_addr2: paymentData?.cus_addr2, cus_city: paymentData?.cus_city, cus_state: paymentData?.cus_state, cus_zip: paymentData?.cus_zip, accountId: accountId, customerId: customerId };

            axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/bank-payment-by-payment-intent', postData).then(async (response) => {
                let paymentAuthData = { tenantId: tenantDet?.id, amount: paymentData?.amount.toFixed(2) };
                localStorage.setItem("paymentAuthData", JSON.stringify(paymentAuthData));

                setLoading(false);
                navigate.push(`/payment-success`);
            }).catch((error) => {
                setLoading(false);
            });

        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!isSecondPaymentStep || !paymentData || paymentType !== 'applepay') return;

        if (isSecondPaymentStep && paymentData) {
            if (!stripe) return;

            let stripeCharge = parseFloat(paymentData?.amount) * 2.9 / 100;
            stripeCharge = stripeCharge.toFixed(2);
            stripeCharge = parseFloat(stripeCharge);

            let tootalAmount = parseFloat(paymentData?.amount) + stripeCharge;

            setTotalAmount(tootalAmount);

            const pr = stripe.paymentRequest({
                country: "US",
                currency: "usd",
                total: {
                    label: paymentData?.description,
                    amount: tootalAmount * 100
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });

            pr.canMakePayment().then(result => {
                if (result) {
                    setPaymentRequest(pr);
                }
            });
        }
    }, [stripe, isSecondPaymentStep, paymentData, paymentType]);

    useEffect(() => {
        if (!isSecondPaymentStep || !paymentData || paymentType !== 'cashapp') return;

        if (clientSecret) return;

        if (isSecondPaymentStep && paymentData) {
            let stripeCharge = parseFloat(paymentData?.amount) * 2.9 / 100;
            stripeCharge = stripeCharge.toFixed(2);
            stripeCharge = parseFloat(stripeCharge);

            let tootalAmount = parseFloat(paymentData?.amount) + stripeCharge;

            setTotalAmount(tootalAmount);

            axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/create-payment-intent", { total_amount: tootalAmount, amount: paymentData?.amount, description: paymentData?.description, cus_name: paymentData?.cus_name, cus_phone: paymentData?.cus_phone, rentRollId: paymentData?.rentRollId, tenantId: paymentData?.tenantId, tenantInfoId: paymentData?.tenantInfoId }).then(async (result) => {
                setClientSecret(result.data.clientSecret);

                // 2. Create isolated Stripe instance
                const stripe = await stripePromise;
                stripeRef.current = stripe;

                // 3. Create isolated Elements instance
                const elements = stripe.elements({ clientSecret: result.data.clientSecret });
                elementsRef.current = elements;

                // 4. Mount Payment Element manually
                const paymentElement = elements.create("payment");
                paymentElementRef.current = paymentElement;
                paymentElement.mount(elementContainer.current);
            }).catch((error) => { });
        }

    }, [isSecondPaymentStep, paymentData, paymentType]);

    useEffect(() => {
        if (!isSecondPaymentStep || !paymentData || paymentType !== 'cardpay') return;

        if (clientSecret2) return;

        if (isSecondPaymentStep && paymentData) {
            let stripeCharge = parseFloat(paymentData?.amount) * 2.9 / 100;
            stripeCharge = stripeCharge.toFixed(2);
            stripeCharge = parseFloat(stripeCharge);

            let tootalAmount = parseFloat(paymentData?.amount) + stripeCharge;

            setTotalAmount(tootalAmount);

            axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/create-payment-intent3", { total_amount: tootalAmount, amount: paymentData?.amount, description: paymentData?.description, cus_name: paymentData?.cus_name, cus_phone: paymentData?.cus_phone, rentRollId: paymentData?.rentRollId, tenantId: paymentData?.tenantId, tenantInfoId: paymentData?.tenantInfoId }).then(async (result) => {
                setClientSecret2(result.data.clientSecret);

                /*// 2. Create isolated Stripe instance
                const stripe = await stripePromise;
                stripeRef.current = stripe;

                // 3. Create isolated Elements instance
                const elements2 = stripe.elements({
                    clientSecret: result.data.clientSecret,
                    paymentMethodOrder: ['card'],
                });
                elementsRef2.current = elements2;

                // 4. Mount Payment Element manually
                const paymentElement2 = elements2.create("payment");
                paymentElementRef2.current = paymentElement2;
                paymentElement2.mount(elementContainer2.current);*/
            }).catch((error) => { });
        }

    }, [isSecondPaymentStep, paymentData, paymentType]);

    useEffect(() => {
        if (!isSecondPaymentStep || !paymentData || paymentType !== 'klarna') return;

        if (clientSecret) return;

        if (isSecondPaymentStep && paymentData) {
            let stripeCharge = parseFloat(paymentData?.amount) * 6 / 100;
            stripeCharge = stripeCharge.toFixed(2);
            stripeCharge = parseFloat(stripeCharge);

            let tootalAmount = parseFloat(paymentData?.amount) + stripeCharge;

            setTotalAmount(tootalAmount);

            axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/create-klarna-payment-intent", { total_amount: tootalAmount, amount: paymentData?.amount, description: paymentData?.description, cus_name: paymentData?.cus_name, cus_phone: paymentData?.cus_phone, rentRollId: paymentData?.rentRollId, tenantId: paymentData?.tenantId, tenantInfoId: paymentData?.tenantInfoId }).then(async (result) => {
                setClientSecret(result.data.clientSecret);

                // 2. Create isolated Stripe instance
                const stripe = await stripePromise;
                stripeRef.current = stripe;

                // 3. Create isolated Elements instance
                const elements = stripe.elements({ clientSecret: result.data.clientSecret });
                elementsRef.current = elements;

                // 4. Mount Payment Element manually
                const paymentElement = elements.create("payment");
                paymentElementRef.current = paymentElement;
                paymentElement.mount(elementContainer.current);
            }).catch((error) => { });
        }

    }, [isSecondPaymentStep, paymentData, paymentType]);

    useEffect(() => {
        if (paymentRequest) {
            paymentRequest.on("paymentmethod", async (event) => {
                try {
                    axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/create-payment-intent2", { total_amount: totalAmount, amount: paymentData?.amount, description: paymentData?.description, cus_name: paymentData?.cus_name, cus_phone: paymentData?.cus_phone, rentRollId: paymentData?.rentRollId, tenantId: paymentData?.tenantId, tenantInfoId: paymentData?.tenantInfoId }).then(async (result) => {

                        const { error } = await stripe.confirmCardPayment(
                            result.data.clientSecret,
                            { payment_method: event.paymentMethod.id },
                            { handleActions: false }
                        );

                        if (error) {
                            event.complete("fail");
                        } else {
                            event.complete("success");
                        }
                    }).catch((error) => { });


                } catch (err) {
                    event.complete("fail");
                }
            });
        }
    }, [paymentRequest]);

    const handlePay = async () => {
        const stripe = stripeRef.current;
        const elements = elementsRef.current;

        let paymentAuthData = { tenantId: tenantDet?.id, amount: paymentData?.amount.toFixed(2) };
        localStorage.setItem("paymentAuthData", JSON.stringify(paymentAuthData));

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: window.location.origin + "/payment-success",
            },
        });

        if (error) alert(error.message);
    }

    const handlePay2 = async () => {
        const stripe = stripeRef.current;
        const elements2 = elementsRef2.current;

        let paymentAuthData = { tenantId: tenantDet?.id, amount: paymentData?.amount.toFixed(2) };
        localStorage.setItem("paymentAuthData", JSON.stringify(paymentAuthData));

        const { error } = await stripe.confirmPayment({
            elements2,
            confirmParams: {
                return_url: window.location.origin + "/payment-success",
            },
        });

        if (error) alert(error.message);
    }

    const handlePayKlarna = async () => {
        const stripe = stripeRef.current;

        let paymentAuthData = { tenantId: tenantDet?.id, amount: paymentData?.amount.toFixed(2) };
        localStorage.setItem("paymentAuthData", JSON.stringify(paymentAuthData));

        const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
            return_url: window.location.origin + "/payment-success",
        });

        if (error) {
            console.error(error.message);
        }
    }

    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!stripe || !cardElements) return;

        const cardElement = cardElements.getElement(CardElement);

        const cardNumberElement = cardElements.getElement(CardNumberElement);

        let paymentAuthData = { tenantId: tenantDet?.id, amount: paymentData?.amount.toFixed(2) };
        localStorage.setItem("paymentAuthData", JSON.stringify(paymentAuthData));

        const { error, paymentIntent } =
            await stripe.confirmCardPayment(clientSecret2, {
                payment_method: {
                    card: cardNumberElement,
                    billing_details: {
                        name: paymentData.cus_name,
                        phone: paymentData.cus_phone,
                    },
                },
            });

        if (error) {
            setError(error.message);
            setLoading(false);
            return;
        }

        if (paymentIntent.status === "succeeded") {
            window.location.href = "/payment-success";
        }

    }

    return (<div className={`${styles.PayNowSec}`}>
        <FormControl className={`${styles.RadioFormControl}`}>
            <RadioGroup name="paymentType" value={paymentType} onChange={(e) => { setPaymentType(e.target.value); setSelectedAccount(null); }}>
                <FormControlLabel value="cashapp" className={`${styles.PaymentRadioList}`} control={<Radio />} label={
                    <div className={`${styles.PaymentFullSec}`}>
                        <p className={`${styles.PaymentListTitle}`}>Pay by Cash App Pay</p>
                        {paymentType === "cashapp" && <p className={`${styles.InfoText}`}>***Stripe charge 2.9% is applied</p>}
                    </div>
                } />
                {/*<FormControlLabel value="applepay" className={`${styles.PaymentRadioList}`} control={<Radio />} label={
                    <div className={`${styles.PaymentFullSec}`}>
                        <p className={`${styles.PaymentListTitle}`}>Pay by Apple Pay</p>
                        {paymentType === "applepay" && <p className={`${styles.InfoText}`}>***Stripe charge 2.9% is applied</p>}
                    </div>
                } />*/}
                <FormControlLabel value="cardpay" className={`${styles.PaymentRadioList}`} control={<Radio />} label={
                    <div className={`${styles.PaymentFullSec}`}>
                        <p className={`${styles.PaymentListTitle}`}>Pay by Credit Card</p>
                        {paymentType === "cardpay" && <p className={`${styles.InfoText}`}>***Stripe charge 2.9% is applied</p>}
                    </div>
                } />
                <FormControlLabel value="klarna" className={`${styles.PaymentRadioList}`} control={<Radio />} label={
                    <div className={`${styles.PaymentFullSec}`}>
                        <p className={`${styles.PaymentListTitle}`}>Pay by Klarna</p>
                        {paymentType === "klarna" && <p className={`${styles.InfoText}`}>***Stripe charge 6% is applied</p>}
                    </div>
                } />
            </RadioGroup>
        </FormControl>

        {/* {paymentType && <div>***Stripe charge 2.9% is applied</div>} */}

        {clientSecret && paymentType === 'klarna' && <div style={{ width: '100%' }}>
            <div ref={elementContainer} style={{ display: 'none' }} />
            <button onClick={handlePayKlarna} className={`${styles.RentallAppliSubmitBU}`}>Pay By Klarna ${totalAmount.toLocaleString('en', { minimumFractionDigits: 2 })}</button>
        </div>}

        {clientSecret && paymentType === 'cashapp' && <div style={{ width: '100%' }}>
            <div ref={elementContainer} style={{ display: 'none' }} />
            <button onClick={handlePay} className={`${styles.RentallAppliSubmitBU}`}>Pay By Cash App ${totalAmount.toLocaleString('en', { minimumFractionDigits: 2 })}</button>
        </div>}

        {clientSecret2 && paymentType === 'cardpay' && <div className={`${styles.CardPayMainSec} CardPayMainSec`}>
            <form onSubmit={handleSubmit}>
                <div className={`${styles.CreditCardRow}`}>
                    <div className={`${styles.CreditCardFull}`}>
                        <div className={`${styles.CreditCardFullUnder}`}>
                            <CardNumberElement />
                        </div>
                    </div>

                    <div className={`${styles.CreditCardHalf}`}>
                        <div className={`${styles.CreditCardHalfUnder}`}>
                            <CardExpiryElement />
                        </div>
                    </div>
                    <div className={`${styles.CreditCardHalf}`}>
                        <div className={`${styles.CreditCardHalfUnder}`}>
                            <CardCvcElement />
                        </div>
                    </div>
                </div>

                {error && <p style={{ color: "red" }}>{error}</p>}

                <button disabled={!stripe} className={`${styles.RentallAppliSubmitBU}`}>Pay ${totalAmount.toLocaleString('en', { minimumFractionDigits: 2 })}</button>
            </form>
        </div>}

        {/*paymentRequest && paymentType === 'applepay' && <div style={{ width: '100%' }}>
            <PaymentRequestButtonElement
                options={{ paymentRequest }}
                style={{ paymentRequestButton: { type: "applePay", theme: "black", height: '40px', width: '100px' } }}
            />
        </div>*/}

        <div className={`${styles.RadioConnectSec}`}>
            <p className={`${styles.Title}`}>Connected Account</p>
            <FormControl className={`${styles.RadioFormControl}`}>
                <RadioGroup name="paymentAccType" value={selectedAccount} onChange={(e) => { setSelectedAccount(e.target.value); setPaymentType(null); }}>
                    {connectedAccounts?.map(item => {
                        return <FormControlLabel value={"acct_" + item?.fc_account_id} className={`${styles.PaymentRadioList}`} control={<Radio />} label={
                            <div className={`${styles.PaymentFullSec}`}>
                                <p className={`${styles.PaymentListTitle}`}>{item?.display_name}</p>
                                <p className={`${styles.PaymentListSubTitle}`}>{'XXXXXXX' + item?.last4}</p>
                            </div>
                        } />
                    })}
                </RadioGroup>
                <button className={`${styles.ConnectAccBURadio}`} onClick={(e) => connectAccount()}><Link /> Connect Another Account</button>
            </FormControl>
        </div>
        {selectedAccount && <button type="button" className={`${styles.RentallAppliSubmitBU}`} onClick={(e) => bankPaymentConfirm()}>Pay ${paymentData?.total_amount.toLocaleString('en', { minimumFractionDigits: 2 })}</button>}

    </div>);
}

export default Step2;